import React, { useEffect, useMemo, useState } from "react";
import "./UserRole.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import UserRoleList from "./UserRoleList";
import AddUserRole from "./AddUserRole";
import store from "../../../store/store";
import {
  fetchAllSecurityGroups,
  fetchPermissions,
} from "../../../store/api/common";
import UpdateUserRole from "./UpdateUserRole";
import ErrorPopup from "../../dialogBox/errorModal";
import SuccessDialog from "../../dialogBox/successDialog";
import { Clear, Done, ExpandMore } from "@mui/icons-material";
import { createCustomSecurityGroupApi, updateCustomSecurityGroupApi } from "../../../store/api/party";
import { isValidStringInput } from "../../../shared/utils/validator";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PageMessage from "../../pageMessage/pageMessage";
import { MESSAGE_TYPES, ROLE_MAP } from "../../../shared/constants/constants";
import { getUserContext } from "../../../shared/utils/utils";

// type Props = {
//   roles:any[],
//   setAvailableRoles: React.Dispatch<React.SetStateAction<any[]>>
// }
// const UserRole = ({roles,setAvailableRoles}:Props) => {
//   const [addRoleClicked,setAddRoleClicked] = useState(false)
//   const [permissions, setPermissions] = useState<any[]>([]);
//   const [permIdMap,setPermIdMap] = useState([])
//   // const [idToPermMap,setIdToPermMap] = useState([])
//   const [updateRoleClicked, setUpdateRoleClicked] = useState(false);
//   const [selectedRole, setSelectedRole] = useState(null);
//   const [success, setSuccess] = useState({ open: false, message: '' });
//   const [error, setError] = useState({ open: false, message: '' });
//  const handleOpenAction = () => {
//   setAddRoleClicked(true);
//   };
//   const cancelAdd = ()=> {
//     setAddRoleClicked(false);
//   }
//   const handleEditRole = (role: any) => {
//     setSelectedRole(role);
//     setUpdateRoleClicked(true);
//   }
//   const cancelUpdate=  ()=> {
//     setUpdateRoleClicked(false)
//     setSelectedRole(null); // Reset selected role when cancelling update
//   }
//   const handleCloseError = () => {
//     setError({ ...error, open: false });
// };
//   const handleCloseSuccess = () => {
//     setSuccess({ ...error, open: false });
// };
//   const handleSetSuccess = (message:string)=> {
//     setSuccess({message,open:true})
//   }
//   const handleSetError = (message:string)=> {
//     setError({message,open:true})
//   }
//    useEffect(() => {
//     store
//       .dispatch(fetchPermissions())
//       .unwrap()
//       .then((payload) => {
//         // console.log(payload)
//         const perm = payload.data.map((data:any)=>{
//           return {
//             permName:data.name,
//             id:data._id
//           }
//         })
//         // console.log(perm)
//         setPermissions(perm)
//       })
//       .catch((error) => {
//         console.log(error)
//       });
//   }, []);

//   useEffect(()=> {
//     const obj:any = []
//     // const obj2 :any = []
//     permissions.forEach((element) => {
//       // console.log(element)
//       obj[element.permName] = element.id
//       // obj2[element.id] = element.permName
//     });
//     // console.log(obj2)
//     setPermIdMap(obj)
//     // setIdToPermMap(obj2)
//   },[permissions])

//   return (
//     <>
//     <Box className="userRoleMainContainer">

//       {
//         !addRoleClicked && !updateRoleClicked? <UserRoleList handleOpenAction={handleOpenAction} allPermissions={permissions} defaultRoles={roles} handleEditRole={handleEditRole}/>
//         :
//         !updateRoleClicked? <AddUserRole cancelAdd={cancelAdd} permIdMap={permIdMap} handleSetSuccess={handleSetSuccess} handleSetError={handleSetError} setAvailableRoles={setAvailableRoles}/>
//         :
//         <UpdateUserRole cancelUpdate={cancelUpdate} role={selectedRole} permIdMap={permIdMap} setAvailableRoles={setAvailableRoles} handleSetSuccess={handleSetSuccess} handleSetError={handleSetError}/>
//       }
//     </Box>
//     <ErrorPopup
//           open={error.open}
//           message={error.message}
//           onClose={handleCloseError}
//         />
//         <SuccessDialog
//           open={success.open}
//           message={success.message}
//           onClose={handleCloseSuccess}
//         />
//     </>
//   )
// }

const UserRole = () => {
  const [allRoles, setAllRoles] = useState<any>({});
  const [allPerms, setAllPerms] = useState<any[]>([]);
  const [allPermGrp, setAllPermGrp] = useState<any>({});
  const [allManPerm, setAllManPerm] = useState<any>({});
  const [currPermGrp, setCurrPermGrp] = useState<any>();
  const [currPermArr, setCurrPermArr] = useState<any[]>([]);
  const [currEditGrp, setCurrEditGrp] = useState<any>({
    groupId:"",
    groupName:"",
    permissions:[]
  });
  const [currEditArr, setCurrEditArr] = useState<any[]>([]);
  const [roleName, setRoleName] = useState("");
  const [roleNameErr, setRoleNameErr] = useState<string>("");
  const [type, setType] = useState<any>('VIEW');
  const [tabValue, setTabValue] = useState<string>("");
  const [showResult, setShowResult] = useState({
    message: "",
    type:""
  })
  const [check, setCheck] = useState<any>({});
  const [update, setUpdate] = useState<boolean>(false);

  const userContext: any = getUserContext();
  const orgPartyId = userContext.orgPartyIds[0];

  useEffect(() => {
    const dispatchers = async () => {
      const rolesObject: any = {};
      const permissionsObject: any = {};
      const permArray: any[] = [];
      let currObject = "";
      const mandPerm: any[] = [];

      await store
        .dispatch(fetchPermissions())
        .unwrap()
        .then((res) => {
          setAllPerms(res.data)
          res?.data?.forEach((ele: any) => {
            if (!ele?.name.includes("SECURITY")) {
              if (rolesObject.hasOwnProperty(ele?.groupName) && rolesObject[ele?.groupName].hasOwnProperty(ele?.groupSubname)) {
                if(ele?.groupSubname){
                  rolesObject[ele?.groupName]?.[ele?.groupSubname]?.push(ele);
                }
                else{
                  rolesObject[ele?.groupName]?.[ele?.groupname]?.push(ele);
                }
              } else {
                if(ele?.groupSubname){
                  rolesObject[ele?.groupName] = {
                    ...rolesObject[ele?.groupName],
                    [ele?.groupSubname]: [ele]
                  };
                }
                else{
                  rolesObject[ele?.groupName] = {
                    ...rolesObject[ele?.groupName],
                    [ele?.groupName]: [ele]
                  };
                } 
              }
            }
            if(ele?.isMandatory){
              check[ele?.name] = true;
              mandPerm.push(ele);
            }
            else{
              check[ele?.name] = false;
            }
          });
        });
      await store
        .dispatch(fetchAllSecurityGroups())
        .unwrap()
        .then((res) => {
          res?.data?.forEach((ele: any, index: number) => {
            permissionsObject[ele?.groupId] = ele;
            if (index === 0) {
              currObject = ele;
              ele?.permissions?.forEach((perm: any) => {
                permArray.push(perm?._id);
              });
            }
          });
        });

      // console.log(rolesObject);
      // console.log(permissionsObject);
      setAllRoles(rolesObject);
      setAllPermGrp(permissionsObject);
      setCurrPermGrp({});
      setCurrPermArr([]);
      setAllManPerm(mandPerm);
      setCheck({...check})
    };
    dispatchers();
  }, [update]);

  useEffect(() => {
    // console.log(currPermGrp);
    // console.log(allPermGrp);
    // console.log(allRoles);
    // console.log(allManPerm);
  }, [currPermGrp, allPermGrp, allRoles, allManPerm]);

  useEffect(() => {
    // console.log(currEditArr);
    // console.log(currEditGrp);
    // console.log(check);
  }, [currEditArr, currEditGrp,  check]);

  useEffect(()=>{
    // console.log(tabValue);
  },[tabValue])

  useEffect(()=>{
    if(showResult.message!==""){
      setTimeout(()=>{
        setShowResult({
          message:"",
          type:""
        })
      },3000)
    }
  },[showResult])

  const changeCurrPermGrp = (key: any) => {
    setCurrPermGrp(allPermGrp[key]);
    const permArray: any[] = [];
    const newCheck:any = {}
    Object.keys(check).forEach((key)=>{
      newCheck[key] = false;
    })
    allPermGrp[key]?.permissions?.forEach((perm: any) => {
      permArray.push(perm?._id);
      newCheck[perm?.name] = true;
    });
    setCurrPermArr(permArray);
    setCheck({...newCheck})
  };

  const permCheck = (event:React.ChangeEvent<HTMLInputElement>, role: any)=>{
    // console.log(role)
    if(event.target.checked){
      const addObj: any[] = []
      const addArr: any[] = []
      const newCheck: any = {}
      newCheck[role?.name] = true;
      allPerms?.forEach((roleE: any)=>{
        if(ROLE_MAP[roleE?.name] && ROLE_MAP[roleE?.name].includes(role?.name) && !check[roleE?.name]){
          addObj.push(roleE);
          addArr.push(roleE?._id);
          newCheck[roleE?.name] = true;
        }
      })
      // console.log(newCheck)
      setCurrEditArr([...currEditArr, ...addArr, role?._id]);
      setCurrEditGrp({...currEditGrp, permissions: [...currEditGrp?.permissions, ...addObj, {...role}]})
      setCheck({...check, ...newCheck});
    }
    else{
      setCurrEditArr(currEditArr.filter((e)=>e!==role?._id));
      const newArr: any = [];
      const newCheck: any = {}
      currEditGrp?.permissions?.forEach((item: any)=>{
        if(item._id!==role?._id){
          newArr?.push(item)
        }
        else{
          newCheck[role?.name] = false;
        }
      })
      setCurrEditGrp({...currEditGrp, permissions: newArr})
      setCheck({...newCheck})
    }
  }

  const updateRole = async ()=>{
    const reqBody = {
      groupId: currPermGrp?.groupId,
      groupName: currPermGrp?.groupName,
      permissions: currEditArr
    }
    await store.dispatch(updateCustomSecurityGroupApi(reqBody)).unwrap().then((res)=>{
      // console.log(res);
      if(res.status!==201){
        setShowResult({
          message: "Error Updating Role",
          type: MESSAGE_TYPES.ERROR
        })
      }
      else{
        setShowResult({
          message: "Role Updated Successfully",
          type: MESSAGE_TYPES.SUCCESS
        })
        setUpdate(!update)
        setType("VIEW")
      }
    }).catch((err)=>{
      // console.log(err);
      setShowResult({
        message: "Error Updating Role",
        type: MESSAGE_TYPES.ERROR
      })
    })
  }

  const createRole = async ()=>{
    if(roleName==="" || !isValidStringInput(roleName)){
      setRoleNameErr("Invalid Role Name")
      return;
    }
    setRoleNameErr("")
    const reqBody = {
      groupId: roleName.toUpperCase().replaceAll(" ","_"),
      groupName: roleName,
      permissions: currEditArr
    }
    await store.dispatch(createCustomSecurityGroupApi(reqBody)).unwrap().then((res)=>{
      // console.log(res);
      if(res.status!==201){
        setShowResult({
          message: "Error Creating Role",
          type: MESSAGE_TYPES.ERROR
        })
      }
      else{
        setShowResult({
          message: "Role Created Successfully",
          type: MESSAGE_TYPES.SUCCESS
        })
        setUpdate(!update)
        setType("VIEW")
      } 
    }).catch((err)=>{
      console.log(err);
      setShowResult({
        message: "Error Creating Role",
        type: MESSAGE_TYPES.ERROR
      })
    })
  }

  const handleTab = (event: React.SyntheticEvent, newValue: string)=>{
    setTabValue(newValue)
  }

  const necessaryChecker = (perm: any)=>{
    let bool = false;
    ROLE_MAP[perm]?.forEach((ele: any)=>{
      if(check[ele]){
        bool=true;
      }
    })
    return bool
  }

  // console.log(currPermGrp?.groupId)

  const el = useMemo(() => {
    return (
      <Stack spacing={1}>
        <Box display={"flex"} gap={1}>
        {type!=="ADD" && <FormControl sx={{width:"85%"}} disabled={type!=="VIEW"}>
          <InputLabel>Select Role</InputLabel>
          <Select
            value={currPermGrp?.groupId?? "DEFAULT VIEW ROLE"}
            // defaultValue={currPermGrp?.groupId+0}
            label="Select Role"
            onChange={(e) => changeCurrPermGrp(e.target.value)}
          >
            <MenuItem
                  key={"DEFAULT VIEW ROLE"}
                  value={"DEFAULT VIEW ROLE"}
                >
                  {"DEFAULT VIEW ROLE"}
                </MenuItem>
            {Object.keys(allPermGrp)?.map((element: any, index: number) => {
              if(allPermGrp[element].partyId && allPermGrp[element].partyId === orgPartyId){
                return (
                  <MenuItem
                    key={allPermGrp[element]?.groupId + index}
                    value={allPermGrp[element]?.groupId}
                  >
                    {allPermGrp[element]?.groupName}
                  </MenuItem>
                );
              }
            })}
          </Select>   
        </FormControl>}
        {type==="ADD" && <Stack sx={{ width: "85%" }}>
            <FormControl variant="outlined">
               <InputLabel htmlFor="outlined-adornment-roleName">
                      Enter Role Name
                    </InputLabel>
              <OutlinedInput
                id="outlined-adornment-roleName"
                type={"text"}
                value={roleName}
                label="Enter Role Name"
                error={roleNameErr!==""}
                onChange={(e) =>setRoleName(e.target.value)}
              />
              <FormHelperText error={roleNameErr!==""}>{roleNameErr}</FormHelperText>
            </FormControl>
          </Stack>}
        {type==="VIEW" && currPermGrp?.groupId  && <Button onClick={()=>{
          setType('EDIT')
          setCurrEditArr([...currPermArr])
          setCurrEditGrp({...currPermGrp})
        }} variant="contained" sx={{borderRadius: 0, width: {lg:"15%", sm: "25%"}, backgroundColor:"#22438C"}} disabled={!currPermGrp || Object.keys(currPermGrp)?.length===0}>
          Edit Role
        </Button>}
        {type==="VIEW" && <Button onClick={()=>{
          setType('ADD')
          setCurrEditArr(allManPerm?.map((perm: any)=>{
            return perm?._id;
          }))
          setCurrEditGrp({
            groupId:"",
            groupName:"",
            permissions:[...allManPerm]
          })
        }} variant="contained" sx={{borderRadius: 0, width: {lg:"15%", sm: "25%"}, backgroundColor:"#22438C"}}>
          Add Role
        </Button>}
        {type!=="VIEW" && <Button onClick={()=>{
          type==='ADD'?createRole():updateRole();
        }} variant="contained" sx={{borderRadius: 0, width: {lg:"15%", sm: "25%"}, height:"56px" , backgroundColor:"#22438C"}}>
          {type==='ADD'?"Create Role":"Update Role"}
        </Button>}
        {type!=="VIEW" && <Button className="cancel-btn" onClick={()=>{
          setType('VIEW')
          setCurrEditArr([])
          setCurrEditGrp({})
        }} variant="contained" sx={{borderRadius: 0, width: {lg:"15%", sm: "25%"}, height:"56px" , backgroundColor:"#F0F0F0", color:"#22438C"}}>
          Cancel
        </Button>}
        </Box>

        {Object.keys(allRoles)?.map((element) => {
          return (
            <Accordion key={element}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{ backgroundColor: "#F7F7F7" }}
              >
                {element.replaceAll("_"," ")}
              </AccordionSummary>
              <AccordionDetails>
                <TabContext value={(tabValue === "" ||  !tabValue.includes(element))?(element+"_"+Object.keys(allRoles?.[element])?.[0]):tabValue}>
                <Stack direction={"row"}>
                  <TabList
                  textColor="inherit"
                  variant="fullWidth"
                  orientation="vertical"
                  // value={tabValue}
                  onChange={handleTab}
                  sx={{borderRight:1, borderColor:"divider"}}
                  >
                    {
                      Object.keys(allRoles?.[element])?.map((subelement)=>{
                        return(
                          <Tab className="tab-head" label={subelement.replace("_"," ")} key={element+"_"+subelement} value={element+"_"+subelement}/>
                          )
                      })
                    }
                  </TabList>
                  {
                    Object.keys(allRoles?.[element])?.map((subelement)=>{
                      return(
                        <TabPanel value={element+"_"+subelement} key={element+"_"+subelement}>
                          <Stack direction={"row"} spacing={2}>
                        {
                          allRoles?.[element]?.[subelement]?.sort((a: any,b: any)=>{
                            return (a?.description.localeCompare(b?.description));
                          })?.map((role:any)=>{
                            return(
                              <Stack direction={"row"}>
                            {type!=="VIEW"?
                            <Checkbox
                              sx={{
                                color: "#22438C",
                                "&.Mui-checked": {
                                  color: "#22438C",
                                },
                              }}
                              checked={role?.isMandatory || (currEditArr?.includes(role?._id))}
                              onChange={(e)=>permCheck(e, role)}
                              disabled={role?.isMandatory || necessaryChecker(role?.name)}
                            />
                            :
                            ((role?.isMandatory || currPermArr?.includes(role?._id))?<Done sx={{color:"#389E0F"}}/>:<Clear sx={{color:"#CD020C"}}/>)}
                            <Typography alignContent={"center"}>
                              {role?.description}
                            </Typography>
                            {role?.isMandatory?<Typography color={"red"} alignContent={"center"}>*</Typography>:""}
                          </Stack>
                            )
                          })
                        }
                        </Stack>
                        </TabPanel>
                        )
                    })
                  }
                  {/* <Stack>
                    {allRoles?.[element]?.map((role: any) => {
                      if(type!=='VIEW' || currPermArr?.includes(role?._id)){
                        return (
                          <Stack direction={"row"}>
                            <Checkbox
                              sx={{
                                color: "#22438C",
                                "&.Mui-checked": {
                                  color: "#22438C",
                                },
                              }}
                              checked={role?.isMandatory || (type==="VIEW"?currPermArr?.includes(role?._id):currEditArr?.includes(role?._id))}
                              onChange={(e)=>permCheck(e, role)}
                              disabled={role?.isMandatory}
                            />
                            <Typography alignContent={"center"}>
                              {role?.description}
                            </Typography>
                            {role?.isMandatory?<Typography color={"red"} alignContent={"center"}>*</Typography>:""}
                          </Stack>
                        );
                      }
                    })}
                  </Stack> */}
                  
                </Stack>
                </TabContext>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Stack>
    );
  }, [allRoles, allPermGrp, currPermGrp, type, currEditArr, currEditGrp, roleName, roleNameErr, allManPerm, tabValue, check, currPermArr]);

  return (
    <Box>
      {showResult?.message!=="" && <Box mb={2}><PageMessage content={showResult?.message} type={showResult?.type}/></Box>}
      {el}
    </Box>
  );
};

export default UserRole;
